import {type JSONData} from "../../base_classes/dto.d";
import {Dto} from "../../base_classes/dto";
import {type IAirlineOrderGroupingDto} from "./dto.gen.d";
import {AirlineOrderGroup} from "../airline_order_group";
import {AirlineOrder} from "../airline_order";

/// ///////////////////////////////////////////////////////////////////////////////////////////////////
/// WARNING! THIS FILE IS AUTOMATICALLY GENERATED, ANY CHANGES WILL BE LOST ON NEXT GENERATION
/// ///////////////////////////////////////////////////////////////////////////////////////////////////

// ENUMS
export enum AirlineOrderGroupingStatus {
  CONCEPT = "concept",
  SENT = "sent",
}

export const AirlineOrderGroupingStatusValues = Object.values(
  AirlineOrderGroupingStatus,
);
export const toAirlineOrderGroupingStatus = (
  s: string,
): AirlineOrderGroupingStatus => {
  switch (s) {
    case "concept":
      return AirlineOrderGroupingStatus.CONCEPT;
    case "sent":
      return AirlineOrderGroupingStatus.SENT;
    default:
      return AirlineOrderGroupingStatus.CONCEPT;
  }
};

export class AirlineOrderGroupingDto
  extends Dto
  implements IAirlineOrderGroupingDto {
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////
  _path = "/airline_order_grouping/{id}";
  _reference = "/AirlineOrderGrouping/{id}";

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////

  afasOrderNumbers = [] as string[];

  finalPrice = 0;

  firstOrderDate = "time.Now()";

  firstDesiredDeliveryDate = "time.Now()";

  invalidOrders: AirlineOrder[] = [];

  _kind = "AirlineOrderGrouping";

  marginAmount = 0;

  marginPercentage = 0;

  name = "";

  orderDate = "time.Now()";

  orderGroups: AirlineOrderGroup[] = [];

  orderIds = [] as string[];

  originalTotalCosts = 0;

  profitAmount = 0;

  profitPercentage = 0;

  savedCosts = 0;

  sentToAfas = false;

  sentToAfasTimestamp = 0;

  status = AirlineOrderGroupingStatus.CONCEPT;

  subtotalCosts = 0;

  totalCosts = 0;

  units = 0;

  totalSalePrice = 0;

  switchCosts = 0;

  /// ///////////////////////////////////////
  /// ///////////// METHODS /////////////////
  /// ///////////////////////////////////////

  static FromJSON(data: unknown): AirlineOrderGroupingDto {
    // Create a new instance of the class
    const obj = new AirlineOrderGroupingDto();
    obj.set(data as JSONData);
    return obj;
  }

  static FromJSONArray(data: unknown[]): AirlineOrderGroupingDto[] {
    return data.map((item) => AirlineOrderGroupingDto.FromJSON(item));
  }

  override set(data: JSONData): void {
    super.set(data);

    // Implement variables here
    if (data.afasOrderNumbers !== undefined && data.afasOrderNumbers !== null) {
      this.afasOrderNumbers =
        (data.afasOrderNumbers as string[]) ?? this.afasOrderNumbers;
    }
    if (data.finalPrice !== undefined && data.finalPrice !== null) {
      this.finalPrice = (data.finalPrice as number) ?? this.finalPrice;
    }
    if (data.firstOrderDate !== undefined && data.firstOrderDate !== null) {
      this.firstOrderDate =
        (data.firstOrderDate as string) ?? this.firstOrderDate;
    }

    if (
      data.invalidOrders !== undefined &&
      data.invalidOrders !== null &&
      Array.isArray(data.invalidOrders)
    ) {
      this.invalidOrders = AirlineOrder.FromJSONArray(
        data.invalidOrders as JSONData[],
      );
    }
    if (data._kind !== undefined && data._kind !== null) {
      this._kind = (data._kind as string) ?? this._kind;
    }
    if (data.marginAmount !== undefined && data.marginAmount !== null) {
      this.marginAmount = (data.marginAmount as number) ?? this.marginAmount;
    }
    if (data.marginPercentage !== undefined && data.marginPercentage !== null) {
      this.marginPercentage =
        (data.marginPercentage as number) ?? this.marginPercentage;
    }
    if (data.name !== undefined && data.name !== null) {
      this.name = (data.name as string) ?? this.name;
    }
    if (data.orderDate !== undefined && data.orderDate !== null) {
      this.orderDate = (data.orderDate as string) ?? this.orderDate;
    }
    if (
      data.orderGroups !== undefined &&
      data.orderGroups !== null &&
      Array.isArray(data.orderGroups)
    ) {
      this.orderGroups = AirlineOrderGroup.FromJSONArray(
        data.orderGroups as JSONData[],
      );
    }
    if (data.orderIds !== undefined && data.orderIds !== null) {
      this.orderIds = (data.orderIds as string[]) ?? this.orderIds;
    }
    if (
      data.originalTotalCosts !== undefined &&
      data.originalTotalCosts !== null
    ) {
      this.originalTotalCosts =
        (data.originalTotalCosts as number) ?? this.originalTotalCosts;
    }
    if (data.profitAmount !== undefined && data.profitAmount !== null) {
      this.profitAmount = (data.profitAmount as number) ?? this.profitAmount;
    }
    if (data.profitPercentage !== undefined && data.profitPercentage !== null) {
      this.profitPercentage =
        (data.profitPercentage as number) ?? this.profitPercentage;
    }
    if (data.savedCosts !== undefined && data.savedCosts !== null) {
      this.savedCosts = (data.savedCosts as number) ?? this.savedCosts;
    }
    if (data.sentToAfas !== undefined && data.sentToAfas !== null) {
      this.sentToAfas = (data.sentToAfas as boolean) ?? this.sentToAfas;
    }
    if (
      data.sentToAfasTimestamp !== undefined &&
      data.sentToAfasTimestamp !== null
    ) {
      this.sentToAfasTimestamp =
        (data.sentToAfasTimestamp as number) ?? this.sentToAfasTimestamp;
    }
    if (data.status !== undefined && data.status !== null) {
      this.status = toAirlineOrderGroupingStatus(
        (data?.status as string) ?? this.status,
      );
    }
    if (data.subtotalCosts !== undefined && data.subtotalCosts !== null) {
      this.subtotalCosts = (data.subtotalCosts as number) ?? this.subtotalCosts;
    }
    if (data.totalCosts !== undefined && data.totalCosts !== null) {
      this.totalCosts = (data.totalCosts as number) ?? this.totalCosts;
    }
    if (data.units !== undefined && data.units !== null) {
      this.units = (data.units as number) ?? this.units;
    }
  }
}
